import { Box, Stack } from '@mui/material';

import { Button, Typography } from 'app/shared';
import { t } from 'i18next';

interface Props {
  onConfirmFn: () => void;
  onCancelFn: () => void;
}

export const PatientConfirmDeleteDialog = ({ onCancelFn, onConfirmFn }: Props) => {
  return (
    <Box sx={{ backgroundColor: 'common.white' }}>
      <Typography padding={3} sx={{ backgroundColor: 'primary.main', color: 'common.white' }}>
        {t('actions.delete')}
      </Typography>
      <Typography padding={3}>{t('patient.confirmDeleteMessage')}</Typography>
      <Stack padding={3} spacing={2} direction={'row'}>
        <Button variant="contained" color="error" onClick={onConfirmFn}>
          {t('actions.delete')}
        </Button>
        <Button variant="text" onClick={onCancelFn}>
          {t('actions.cancel')}
        </Button>
      </Stack>
    </Box>
  );
};
